import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/dashboards';

export async function queryPeriodCounts(country: number | undefined): Promise<any> {
	const url: URL = new URL(rootUrl + '/daily-counts');
	url.searchParams.append('country', String(country))

	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryTotalCounts(country: number | undefined): Promise<any> {
	const url: URL = new URL(rootUrl + '/total-counts');
	url.searchParams.append('country', String(country))

	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryUsersMapData(country: number | undefined): Promise<any> {
	const url: URL = new URL(rootUrl + '/users-map');
	url.searchParams.append('country', String(country))

	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function weeklyUserCount(country: number | undefined): Promise<any> {
	const url: URL = new URL(rootUrl + '/weekly-user-count');
	url.searchParams.append('country', String(country))

	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryRedCrossActivities(): Promise<any> {
	const url: URL = new URL(rootUrl + '/red-cross-activities');
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryNewPosts(): Promise<any> {
	const url: URL = new URL(rootUrl + '/new-posts');
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryPopularPosts(): Promise<any> {
	const url: URL = new URL(rootUrl + '/popular-posts');
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryTotalUserCount(): Promise<any> {
	const url: URL = new URL(rootUrl + '/total-user');
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryUserStories(): Promise<any> {
	const url: URL = new URL(rootUrl + '/user-stories');
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function queryGroupsActivity(): Promise<any> {
	const url: URL = new URL(rootUrl + '/groups-activity');
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function topGroupsActivity(): Promise<any> {
	const url: URL = new URL(rootUrl + '/groups-top-activity');
	const response: Response = await BBApi.get(url.href);
	const json: any = await response.json();
	return json;
}

export async function getSwedenUserCount() {
	const url = new URL(rootUrl + '/sweden/user-count');
	const response = await BBApi.get(url.href);

	const userCount = await response.text();
	return Number(userCount);
}
